import actions from './actions';
import state from './state';
import mutations from './mutations';
import getters from './getters';

const assistant = {
  namespaced: true,
  actions,
  state,
  mutations,
  getters,
};

export default assistant;
